// @ts-ignore
import { gaApiCall, type ApiResult } from "@utils/httpClient";
// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { renderJsonWithNumbersAsBigint, parseJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
import * as schema from "@newgenerated/shared/schema";
import * as mapper from "@newgenerated/shared/mapper";
export async function getBulkLoadActionables(props: { body: schema.ActionableBulkLoadForm }): Promise<ApiResult<schema.ActionableMetadataArray>> {
  const path = "/gaapi/actionables-bulk-load/admin";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_ActionableBulkLoadForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.ActionableMetadataArray> => {
    return mapper.deserialize_ActionableMetadataArray(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getActionableOverview(): Promise<ApiResult<schema.ActionableMetadataArray>> {
  const path = "/gaapi/actionables/admin";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.ActionableMetadataArray> => {
    return mapper.deserialize_ActionableMetadataArray(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function searchActionables(props: { body: schema.ActionableAdminSearchForm; pageRequest: schema.PageRequest }): Promise<ApiResult<schema.PagedActionableMetadata>> {
  let path = "/gaapi/actionables/admin-search";
  const urlSearchParams = new URLSearchParams();
  (() => {
    const outerParsed = ((value) => {
      const outerRendered = ((value) => {
        return mapper.serialize_PageRequest(value);
      })(value);
      const outerParsed = parseJsonWithNumbersAsBigint(outerRendered);
      assert(outerParsed !== null);
      assert(typeof outerParsed === "object");
      return outerParsed;
    })(props.pageRequest);
    assert(hasProp(outerParsed, "page"));
    [outerParsed.page].flat().forEach((value) => {
      urlSearchParams.append(
        "page",
        ((value) => {
          return value;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "psize"));
    [outerParsed.psize].flat().forEach((value) => {
      urlSearchParams.append(
        "psize",
        ((value) => {
          return value;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "sortBy"));
    [outerParsed.sortBy].flat().forEach((value) => {
      if (value === null) return;
      urlSearchParams.append(
        "sortBy",
        ((value) => {
          const parsed_again = parseJsonWithNumbersAsBigint(value);
          assert(typeof parsed_again === "string");
          return parsed_again;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "sortDesc"));
    [outerParsed.sortDesc].flat().forEach((value) => {
      urlSearchParams.append(
        "sortDesc",
        ((value) => {
          const parsed_again = parseJsonWithNumbersAsBigint(value);
          assert(typeof parsed_again === "boolean");
          return parsed_again ? "true" : "false";
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
  })();
  if (urlSearchParams.size > 0) {
    path += "?";
    path += urlSearchParams.toString();
  }
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_ActionableAdminSearchForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.PagedActionableMetadata> => {
    return mapper.deserialize_PagedActionableMetadata(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function toggleLike(props: { feedbackId: bigint }): Promise<ApiResult> {
  let path = "/gaapi/actionables/peerinsight/change-like";
  const urlSearchParams = new URLSearchParams();
  [props.feedbackId].flat().forEach((value) => {
    urlSearchParams.append(
      "feedbackId",
      ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      ),
    );
  });
  if (urlSearchParams.size > 0) {
    path += "?";
    path += urlSearchParams.toString();
  }
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function navigateForm(props: { body: schema.PeerInsightFormNavigation }): Promise<ApiResult<bigint>> {
  const path = "/gaapi/actionables/peerinsight/navigateForm";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_PeerInsightFormNavigation(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<bigint> => {
    const data = parseJsonWithNumbersAsBigint(value);
    return ((value) => {
      if (typeof value === "number") {
        return { success: true, value: BigInt(value) };
      }
      if (typeof value === "bigint") {
        return { success: true, value: value };
      }
      return {
        success: false,
        reason: `[class IntegerSchema {
    class Schema {
        type: integer
        format: int64
        $ref: null
        description: null
        title: null
        multipleOf: null
        maximum: null
        exclusiveMaximum: null
        minimum: null
        exclusiveMinimum: null
        maxLength: null
        minLength: null
        pattern: null
        maxItems: null
        minItems: null
        uniqueItems: null
        maxProperties: null
        minProperties: null
        required: null
        not: null
        properties: null
        additionalProperties: null
        nullable: true
        readOnly: null
        writeOnly: null
        example: null
        externalDocs: null
        deprecated: null
        discriminator: null
        xml: null
    }
}]: '${value}' expected to be of type bigint or number.`,
      };
    })(data);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function deleteById(props: { feedbackId: bigint }): Promise<ApiResult> {
  let path = "/gaapi/actionables/peerinsight/delete-feedback";
  const urlSearchParams = new URLSearchParams();
  [props.feedbackId].flat().forEach((value) => {
    urlSearchParams.append(
      "feedbackId",
      ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      ),
    );
  });
  if (urlSearchParams.size > 0) {
    path += "?";
    path += urlSearchParams.toString();
  }
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function getQuestionKeys(): Promise<ApiResult<schema.PeerInsightQuestionKeysResponse>> {
  const path = "/gaapi/actionables/peerinsight/question-keys";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.PeerInsightQuestionKeysResponse> => {
    return mapper.deserialize_PeerInsightQuestionKeysResponse(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getTextFeedbacks(props: { body: schema.PeerInsightTextFeedbackRequest }): Promise<ApiResult<schema.PagedPeerInsightFeedbackListView>> {
  const path = "/gaapi/actionables/peerinsight/text-feedback";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_PeerInsightTextFeedbackRequest(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.PagedPeerInsightFeedbackListView> => {
    return mapper.deserialize_PagedPeerInsightFeedbackListView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function updateApprovalStatus(props: { body: schema.PeerInsightFeedbackUpdateRequest }): Promise<ApiResult> {
  const path = "/gaapi/actionables/peerinsight/update-feedback";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_PeerInsightFeedbackUpdateRequest(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function toggleBookmarkActionable(props: { actionableId: bigint }): Promise<ApiResult<schema.BookmarkResponse>> {
  let path = "/gaapi/actionables/{actionableId}/bookmark";
  path = path.replace(
    "{actionableId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.actionableId),
  );
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.BookmarkResponse> => {
    return mapper.deserialize_BookmarkResponse(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function setExperienceFeedback(props: { actionableId: bigint; score: number }): Promise<ApiResult> {
  let path = "/gaapi/actionables/{actionableId}/experience-feedback";
  path = path.replace(
    "{actionableId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.actionableId),
  );
  const urlSearchParams = new URLSearchParams();
  [props.score].flat().forEach((value) => {
    urlSearchParams.append(
      "score",
      ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      ),
    );
  });
  if (urlSearchParams.size > 0) {
    path += "?";
    path += urlSearchParams.toString();
  }
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function trackPeerInsightStarted(props: { actionableId: bigint }): Promise<ApiResult> {
  let path = "/gaapi/actionables/{actionableId}/peerinsight-started";
  path = path.replace(
    "{actionableId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.actionableId),
  );
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function trackProTalkVideoProgress(props: { actionableId: bigint; progress: number }): Promise<ApiResult> {
  let path = "/gaapi/actionables/{actionableId}/pro-talk-video-progress";
  path = path.replace(
    "{actionableId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.actionableId),
  );
  const urlSearchParams = new URLSearchParams();
  [props.progress].flat().forEach((value) => {
    urlSearchParams.append(
      "progress",
      ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      ),
    );
  });
  if (urlSearchParams.size > 0) {
    path += "?";
    path += urlSearchParams.toString();
  }
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function trackStep2VideoProgress(props: { actionableId: bigint; progress: number }): Promise<ApiResult> {
  let path = "/gaapi/actionables/{actionableId}/step2-video-progress";
  path = path.replace(
    "{actionableId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.actionableId),
  );
  const urlSearchParams = new URLSearchParams();
  [props.progress].flat().forEach((value) => {
    urlSearchParams.append(
      "progress",
      ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      ),
    );
  });
  if (urlSearchParams.size > 0) {
    path += "?";
    path += urlSearchParams.toString();
  }
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function getChannels(props: { includeInactive: boolean }): Promise<ApiResult<schema.ChannelList>> {
  let path = "/gaapi/admin/channels";
  const urlSearchParams = new URLSearchParams();
  [props.includeInactive].flat().forEach((value) => {
    urlSearchParams.append(
      "includeInactive",
      ((value) => {
        const parsed_again = parseJsonWithNumbersAsBigint(value);
        assert(typeof parsed_again === "boolean");
        return parsed_again ? "true" : "false";
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      ),
    );
  });
  if (urlSearchParams.size > 0) {
    path += "?";
    path += urlSearchParams.toString();
  }
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.ChannelList> => {
    return mapper.deserialize_ChannelList(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getAllAbstracts(props: { listType: string }): Promise<ApiResult<schema.AllAbstractsListWrapperArray>> {
  let path = "/gaapi/all-abstracts/{listType}";
  path = path.replace(
    "{listType}",
    ((value) => {
      return ((value) => {
        const parsed_again = parseJsonWithNumbersAsBigint(value);
        assert(typeof parsed_again === "string");
        return parsed_again;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.listType),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.AllAbstractsListWrapperArray> => {
    return mapper.deserialize_AllAbstractsListWrapperArray(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getCareerOverview(): Promise<ApiResult<schema.CareerListViewList>> {
  const path = "/gaapi/careers/admin";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CareerListViewList> => {
    return mapper.deserialize_CareerListViewList(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getCareerEditView(props: { careerId: bigint }): Promise<ApiResult<schema.CareerEditView>> {
  let path = "/gaapi/careers/{careerId}/admin";
  path = path.replace(
    "{careerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.careerId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CareerEditView> => {
    return mapper.deserialize_CareerEditView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function saveCareer(props: { body: schema.CareerForm; careerId: bigint }): Promise<ApiResult<schema.CareerEditView>> {
  let path = "/gaapi/careers/{careerId}/admin";
  path = path.replace(
    "{careerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.careerId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_CareerForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CareerEditView> => {
    return mapper.deserialize_CareerEditView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getContent(props: { body: schema.ContentMetadataFilterForm }): Promise<ApiResult<schema.ContentMetadataView>> {
  const path = "/gaapi/content";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_ContentMetadataFilterForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.ContentMetadataView> => {
    return mapper.deserialize_ContentMetadataView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getIxStatus(props: { body: schema.ContentIdList }): Promise<ApiResult<schema.ContentIxStatusList>> {
  const path = "/gaapi/content-ix-status";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_ContentIdList(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.ContentIxStatusList> => {
    return mapper.deserialize_ContentIxStatusList(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getContextFlags(): Promise<ApiResult<schema.ContextFlagArr>> {
  const path = "/gaapi/context-flags";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.ContextFlagArr> => {
    return mapper.deserialize_ContextFlagArr(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getCustomPages(props: { corporateId: number; customPageAdminSearchForm: schema.CustomPageAdminSearchForm; pageRequest: schema.PageRequest }): Promise<ApiResult<schema.PagedCustomPageEditListView>> {
  let path = "/gaapi/corporations/{corporateId}/custom-pages";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const urlSearchParams = new URLSearchParams();
  (() => {
    const outerParsed = ((value) => {
      const outerRendered = ((value) => {
        return mapper.serialize_CustomPageAdminSearchForm(value);
      })(value);
      const outerParsed = parseJsonWithNumbersAsBigint(outerRendered);
      assert(outerParsed !== null);
      assert(typeof outerParsed === "object");
      return outerParsed;
    })(props.customPageAdminSearchForm);
    assert(hasProp(outerParsed, "includeInactive"));
    [outerParsed.includeInactive].flat().forEach((value) => {
      urlSearchParams.append(
        "includeInactive",
        ((value) => {
          const parsed_again = parseJsonWithNumbersAsBigint(value);
          assert(typeof parsed_again === "boolean");
          return parsed_again ? "true" : "false";
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "onlyHighlighted"));
    [outerParsed.onlyHighlighted].flat().forEach((value) => {
      urlSearchParams.append(
        "onlyHighlighted",
        ((value) => {
          const parsed_again = parseJsonWithNumbersAsBigint(value);
          assert(typeof parsed_again === "boolean");
          return parsed_again ? "true" : "false";
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "searchTerm"));
    [outerParsed.searchTerm].flat().forEach((value) => {
      urlSearchParams.append(
        "searchTerm",
        ((value) => {
          const parsed_again = parseJsonWithNumbersAsBigint(value);
          assert(typeof parsed_again === "string");
          return parsed_again;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
  })();
  (() => {
    const outerParsed = ((value) => {
      const outerRendered = ((value) => {
        return mapper.serialize_PageRequest(value);
      })(value);
      const outerParsed = parseJsonWithNumbersAsBigint(outerRendered);
      assert(outerParsed !== null);
      assert(typeof outerParsed === "object");
      return outerParsed;
    })(props.pageRequest);
    assert(hasProp(outerParsed, "page"));
    [outerParsed.page].flat().forEach((value) => {
      urlSearchParams.append(
        "page",
        ((value) => {
          return value;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "psize"));
    [outerParsed.psize].flat().forEach((value) => {
      urlSearchParams.append(
        "psize",
        ((value) => {
          return value;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "sortBy"));
    [outerParsed.sortBy].flat().forEach((value) => {
      if (value === null) return;
      urlSearchParams.append(
        "sortBy",
        ((value) => {
          const parsed_again = parseJsonWithNumbersAsBigint(value);
          assert(typeof parsed_again === "string");
          return parsed_again;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "sortDesc"));
    [outerParsed.sortDesc].flat().forEach((value) => {
      urlSearchParams.append(
        "sortDesc",
        ((value) => {
          const parsed_again = parseJsonWithNumbersAsBigint(value);
          assert(typeof parsed_again === "boolean");
          return parsed_again ? "true" : "false";
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
  })();
  if (urlSearchParams.size > 0) {
    path += "?";
    path += urlSearchParams.toString();
  }
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.PagedCustomPageEditListView> => {
    return mapper.deserialize_PagedCustomPageEditListView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getCustomPage(props: { corporateId: number; customPageId: bigint }): Promise<ApiResult<schema.CustomPageEditView>> {
  let path = "/gaapi/corporations/{corporateId}/custom-pages/{customPageId}";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  path = path.replace(
    "{customPageId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customPageId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomPageEditView> => {
    return mapper.deserialize_CustomPageEditView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function archiveCustomPage(props: { corporateId: number; customPageId: bigint }): Promise<ApiResult> {
  let path = "/gaapi/corporations/{corporateId}/custom-pages/{customPageId}/archive";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  path = path.replace(
    "{customPageId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customPageId),
  );
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function copyCustomPage(props: { body: schema.CustomPageCopyRequest; corporateId: number; customPageId: bigint }): Promise<ApiResult<string>> {
  let path = "/gaapi/corporations/{corporateId}/custom-pages/{customPageId}/copy";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  path = path.replace(
    "{customPageId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customPageId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_CustomPageCopyRequest(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<string> => {
    const data = parseJsonWithNumbersAsBigint(value);
    return ((value) => {
      if (typeof value !== "string") {
        return {
          success: false,
          reason: `[class StringSchema {
    class Schema {
        type: string
        format: null
        $ref: null
        description: null
        title: null
        multipleOf: null
        maximum: null
        exclusiveMaximum: null
        minimum: null
        exclusiveMinimum: null
        maxLength: null
        minLength: null
        pattern: null
        maxItems: null
        minItems: null
        uniqueItems: null
        maxProperties: null
        minProperties: null
        required: null
        not: null
        properties: null
        additionalProperties: null
        nullable: null
        readOnly: null
        writeOnly: null
        example: null
        externalDocs: null
        deprecated: null
        discriminator: null
        xml: null
    }
}]: '${value}' expected to be of type string.`,
        };
      }
      return { success: true, value: value };
    })(data);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function searchCustomPages(props: {
  corporateId: number;
  pageRequest: schema.PageRequest;
  customPageAdminSearchForm: schema.CustomPageAdminSearchForm;
  isoCode: schema.Language;
}): Promise<ApiResult<schema.PagedCustomPageListView>> {
  let path = "/gaapi/corporations/{corporateId}/custom-pages/admin-search";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const urlSearchParams = new URLSearchParams();
  (() => {
    const outerParsed = ((value) => {
      const outerRendered = ((value) => {
        return mapper.serialize_PageRequest(value);
      })(value);
      const outerParsed = parseJsonWithNumbersAsBigint(outerRendered);
      assert(outerParsed !== null);
      assert(typeof outerParsed === "object");
      return outerParsed;
    })(props.pageRequest);
    assert(hasProp(outerParsed, "page"));
    [outerParsed.page].flat().forEach((value) => {
      urlSearchParams.append(
        "page",
        ((value) => {
          return value;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "psize"));
    [outerParsed.psize].flat().forEach((value) => {
      urlSearchParams.append(
        "psize",
        ((value) => {
          return value;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "sortBy"));
    [outerParsed.sortBy].flat().forEach((value) => {
      if (value === null) return;
      urlSearchParams.append(
        "sortBy",
        ((value) => {
          const parsed_again = parseJsonWithNumbersAsBigint(value);
          assert(typeof parsed_again === "string");
          return parsed_again;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "sortDesc"));
    [outerParsed.sortDesc].flat().forEach((value) => {
      urlSearchParams.append(
        "sortDesc",
        ((value) => {
          const parsed_again = parseJsonWithNumbersAsBigint(value);
          assert(typeof parsed_again === "boolean");
          return parsed_again ? "true" : "false";
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
  })();
  (() => {
    const outerParsed = ((value) => {
      const outerRendered = ((value) => {
        return mapper.serialize_CustomPageAdminSearchForm(value);
      })(value);
      const outerParsed = parseJsonWithNumbersAsBigint(outerRendered);
      assert(outerParsed !== null);
      assert(typeof outerParsed === "object");
      return outerParsed;
    })(props.customPageAdminSearchForm);
    assert(hasProp(outerParsed, "includeInactive"));
    [outerParsed.includeInactive].flat().forEach((value) => {
      urlSearchParams.append(
        "includeInactive",
        ((value) => {
          const parsed_again = parseJsonWithNumbersAsBigint(value);
          assert(typeof parsed_again === "boolean");
          return parsed_again ? "true" : "false";
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "onlyHighlighted"));
    [outerParsed.onlyHighlighted].flat().forEach((value) => {
      urlSearchParams.append(
        "onlyHighlighted",
        ((value) => {
          const parsed_again = parseJsonWithNumbersAsBigint(value);
          assert(typeof parsed_again === "boolean");
          return parsed_again ? "true" : "false";
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "searchTerm"));
    [outerParsed.searchTerm].flat().forEach((value) => {
      urlSearchParams.append(
        "searchTerm",
        ((value) => {
          const parsed_again = parseJsonWithNumbersAsBigint(value);
          assert(typeof parsed_again === "string");
          return parsed_again;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
  })();
  [props.isoCode].flat().forEach((value) => {
    urlSearchParams.append(
      "isoCode",
      ((value) => {
        const parsed_again = parseJsonWithNumbersAsBigint(value);
        assert(typeof parsed_again === "string");
        return parsed_again;
      })(
        (() => {
          return mapper.serialize_Language(value);
        })(),
      ),
    );
  });
  if (urlSearchParams.size > 0) {
    path += "?";
    path += urlSearchParams.toString();
  }
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.PagedCustomPageListView> => {
    return mapper.deserialize_PagedCustomPageListView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getCustomPagesHighlighted(props: { corporateId: number }): Promise<ApiResult<schema.CustomPageEditListViewArray>> {
  let path = "/gaapi/corporations/{corporateId}/custom-pages/highlighted";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomPageEditListViewArray> => {
    return mapper.deserialize_CustomPageEditListViewArray(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function saveCustomPagesHighlighted(props: { body: schema.CustomPageHighlightsForm; corporateId: number }): Promise<ApiResult<schema.CustomPageEditListViewArray>> {
  let path = "/gaapi/corporations/{corporateId}/custom-pages/highlighted";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({
    path: path,
    method: "PUT",
    requestBody: ((value) => {
      return mapper.serialize_CustomPageHighlightsForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomPageEditListViewArray> => {
    return mapper.deserialize_CustomPageEditListViewArray(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getPortletContainer(props: { corporateId: number; isoCode: schema.Language }): Promise<ApiResult<schema.PortletContainerAdminEditView>> {
  let path = "/gaapi/corporations/{corporateId}/portlet-containers/start-page/languages/{isoCode}";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  path = path.replace(
    "{isoCode}",
    ((value) => {
      return ((value) => {
        const parsed_again = parseJsonWithNumbersAsBigint(value);
        assert(typeof parsed_again === "string");
        return parsed_again;
      })(
        (() => {
          return mapper.serialize_Language(value);
        })(),
      );
    })(props.isoCode),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.PortletContainerAdminEditView> => {
    return mapper.deserialize_PortletContainerAdminEditView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function savePortletContainer(props: { body: schema.PortletContainerAdminEditForm; corporateId: number; isoCode: schema.Language }): Promise<ApiResult<schema.PortletContainerAdminEditView>> {
  let path = "/gaapi/corporations/{corporateId}/portlet-containers/start-page/languages/{isoCode}";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  path = path.replace(
    "{isoCode}",
    ((value) => {
      return ((value) => {
        const parsed_again = parseJsonWithNumbersAsBigint(value);
        assert(typeof parsed_again === "string");
        return parsed_again;
      })(
        (() => {
          return mapper.serialize_Language(value);
        })(),
      );
    })(props.isoCode),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_PortletContainerAdminEditForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.PortletContainerAdminEditView> => {
    return mapper.deserialize_PortletContainerAdminEditView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function deletePortletContainer(props: { corporateId: number; portletContainerId: number }): Promise<ApiResult> {
  let path = "/gaapi/corporations/{corporateId}/portlet-containers/{portletContainerId}";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  path = path.replace(
    "{portletContainerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.portletContainerId),
  );
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function getMyListPortletView(props: { corporateId: number; portletId: number; isoCode: schema.Language }): Promise<ApiResult<schema.MyListPortletView>> {
  let path = "/gaapi/corporations/{corporateId}/portlets/mylist-{portletId}";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  path = path.replace(
    "{portletId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.portletId),
  );
  const urlSearchParams = new URLSearchParams();
  [props.isoCode].flat().forEach((value) => {
    urlSearchParams.append(
      "isoCode",
      ((value) => {
        const parsed_again = parseJsonWithNumbersAsBigint(value);
        assert(typeof parsed_again === "string");
        return parsed_again;
      })(
        (() => {
          return mapper.serialize_Language(value);
        })(),
      ),
    );
  });
  if (urlSearchParams.size > 0) {
    path += "?";
    path += urlSearchParams.toString();
  }
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.MyListPortletView> => {
    return mapper.deserialize_MyListPortletView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getConfigEditView(props: { corporateId: number }): Promise<ApiResult<schema.PromoBoxConfigEditView>> {
  let path = "/gaapi/corporations/{corporateId}/promobox-config";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.PromoBoxConfigEditView> => {
    return mapper.deserialize_PromoBoxConfigEditView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function saveConfig(props: { body: schema.PromoBoxConfigForm; corporateId: number }): Promise<ApiResult<schema.PromoBoxConfigEditView>> {
  let path = "/gaapi/corporations/{corporateId}/promobox-config";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({
    path: path,
    method: "PUT",
    requestBody: ((value) => {
      return mapper.serialize_PromoBoxConfigForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.PromoBoxConfigEditView> => {
    return mapper.deserialize_PromoBoxConfigEditView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getPromoBoxConfigPreview(props: { body: schema.PromoBoxConfigPreviewFilters; corporateId: number }): Promise<ApiResult<schema.PromoBoxConfigPreview>> {
  let path = "/gaapi/corporations/{corporateId}/promobox-config-preview";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_PromoBoxConfigPreviewFilters(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.PromoBoxConfigPreview> => {
    return mapper.deserialize_PromoBoxConfigPreview(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getPromoBoxLibrary(props: { corporateId: number }): Promise<ApiResult<schema.PromoBoxLibraryView>> {
  let path = "/gaapi/corporations/{corporateId}/promoboxes";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.PromoBoxLibraryView> => {
    return mapper.deserialize_PromoBoxLibraryView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getAllActionableSensitiveContents(props: { corporateId: number }): Promise<ApiResult<schema.SensitiveContentListViewList>> {
  let path = "/gaapi/corporations/{corporateId}/sensitive-contents/actionables";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.SensitiveContentListViewList> => {
    return mapper.deserialize_SensitiveContentListViewList(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function saveActionableSensitiveContents(props: { body: schema.ActionableIdsList; corporateId: number }): Promise<ApiResult> {
  let path = "/gaapi/corporations/{corporateId}/sensitive-contents/actionables";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_ActionableIdsList(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function getAllChannelSensitiveContents(props: { corporateId: number }): Promise<ApiResult<schema.SensitiveContentListViewList>> {
  let path = "/gaapi/corporations/{corporateId}/sensitive-contents/channels";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.SensitiveContentListViewList> => {
    return mapper.deserialize_SensitiveContentListViewList(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function saveChannelSensitiveContents(props: { body: schema.ChannelIdsList; corporateId: number }): Promise<ApiResult> {
  let path = "/gaapi/corporations/{corporateId}/sensitive-contents/channels";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_ChannelIdsList(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function getAllSummarySensitiveContents(props: { corporateId: number }): Promise<ApiResult<schema.SensitiveContentListViewList>> {
  let path = "/gaapi/corporations/{corporateId}/sensitive-contents/summaries";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.SensitiveContentListViewList> => {
    return mapper.deserialize_SensitiveContentListViewList(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function saveSummarySensitiveContents(props: { body: schema.SummaryIdsList; corporateId: number }): Promise<ApiResult> {
  let path = "/gaapi/corporations/{corporateId}/sensitive-contents/summaries";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_SummaryIdsList(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function getAllSensitiveTags(props: { corporateId: number }): Promise<ApiResult<schema.CountryRestrictedTagArray>> {
  let path = "/gaapi/corporations/{corporateId}/sensitive-tags";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CountryRestrictedTagArray> => {
    return mapper.deserialize_CountryRestrictedTagArray(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function saveSensitiveTags(props: { body: schema.CountryRestrictedTagArray; corporateId: number }): Promise<ApiResult<schema.CountryRestrictedTagArray>> {
  let path = "/gaapi/corporations/{corporateId}/sensitive-tags";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({
    path: path,
    method: "PUT",
    requestBody: ((value) => {
      return mapper.serialize_CountryRestrictedTagArray(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CountryRestrictedTagArray> => {
    return mapper.deserialize_CountryRestrictedTagArray(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getEmbeddedQuicksightDashboardURI(props: { corporateId: number }): Promise<ApiResult<string>> {
  let path = "/gaapi/corporations/{corporateId}/statistics/dashboard";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<string> => {
    const data = parseJsonWithNumbersAsBigint(value);
    return ((value) => {
      if (typeof value !== "string") {
        return {
          success: false,
          reason: `[class StringSchema {
    class Schema {
        type: string
        format: null
        $ref: null
        description: null
        title: null
        multipleOf: null
        maximum: null
        exclusiveMaximum: null
        minimum: null
        exclusiveMinimum: null
        maxLength: null
        minLength: null
        pattern: null
        maxItems: null
        minItems: null
        uniqueItems: null
        maxProperties: null
        minProperties: null
        required: null
        not: null
        properties: null
        additionalProperties: null
        nullable: null
        readOnly: null
        writeOnly: null
        example: null
        externalDocs: null
        deprecated: null
        discriminator: null
        xml: null
    }
}]: '${value}' expected to be of type string.`,
        };
      }
      return { success: true, value: value };
    })(data);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getEmbeddedHistoricalQuicksightDashboardURI(props: { corporateId: number }): Promise<ApiResult<string>> {
  let path = "/gaapi/corporations/{corporateId}/statistics/historical-dashboard";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<string> => {
    const data = parseJsonWithNumbersAsBigint(value);
    return ((value) => {
      if (typeof value !== "string") {
        return {
          success: false,
          reason: `[class StringSchema {
    class Schema {
        type: string
        format: null
        $ref: null
        description: null
        title: null
        multipleOf: null
        maximum: null
        exclusiveMaximum: null
        minimum: null
        exclusiveMinimum: null
        maxLength: null
        minLength: null
        pattern: null
        maxItems: null
        minItems: null
        uniqueItems: null
        maxProperties: null
        minProperties: null
        required: null
        not: null
        properties: null
        additionalProperties: null
        nullable: true
        readOnly: null
        writeOnly: null
        example: null
        externalDocs: null
        deprecated: null
        discriminator: null
        xml: null
    }
}]: '${value}' expected to be of type string.`,
        };
      }
      return { success: true, value: value };
    })(data);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getCustomerComments(props: { customerId: number }): Promise<ApiResult<schema.CustomerCommentForms>> {
  let path = "/gaapi/customer-comments/{customerId}";
  path = path.replace(
    "{customerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customerId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomerCommentForms> => {
    return mapper.deserialize_CustomerCommentForms(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function createCustomerComment(props: { body: schema.CustomerCommentSaveRequest; customerId: number }): Promise<ApiResult> {
  let path = "/gaapi/customer-comments/{customerId}";
  path = path.replace(
    "{customerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customerId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_CustomerCommentSaveRequest(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function getCustomerDetail(props: { customerId: number }): Promise<ApiResult<schema.CustomerAdminDetailForm>> {
  let path = "/gaapi/customer/{customerId}";
  path = path.replace(
    "{customerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customerId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomerAdminDetailForm> => {
    return mapper.deserialize_CustomerAdminDetailForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function updateCustomerDetails(props: { body: schema.CustomerAdminDetailForm; customerId: number }): Promise<ApiResult<schema.CustomerAdminDetailForm>> {
  let path = "/gaapi/customer/{customerId}";
  path = path.replace(
    "{customerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customerId),
  );
  const response = await gaApiCall({
    path: path,
    method: "PUT",
    requestBody: ((value) => {
      return mapper.serialize_CustomerAdminDetailForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomerAdminDetailForm> => {
    return mapper.deserialize_CustomerAdminDetailForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getLeadPortals(props: { customerId: number }): Promise<ApiResult<schema.CustomerAdminB2BPortalsForms>> {
  let path = "/gaapi/customer/{customerId}/LeadPortals";
  path = path.replace(
    "{customerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customerId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomerAdminB2BPortalsForms> => {
    return mapper.deserialize_CustomerAdminB2BPortalsForms(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getCustomerAccountDetails(props: { customerId: number }): Promise<ApiResult<schema.CustomerAdminAccountDetailForm>> {
  let path = "/gaapi/customer/{customerId}/accountdetails";
  path = path.replace(
    "{customerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customerId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomerAdminAccountDetailForm> => {
    return mapper.deserialize_CustomerAdminAccountDetailForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getB2BPortals(props: { customerId: number }): Promise<ApiResult<schema.CustomerAdminB2BPortalsForms>> {
  let path = "/gaapi/customer/{customerId}/b2bportals";
  path = path.replace(
    "{customerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customerId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomerAdminB2BPortalsForms> => {
    return mapper.deserialize_CustomerAdminB2BPortalsForms(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function deactivateCorporateCustomer(props: { customerId: number; corporateId: number; portalType: schema.PortalType }): Promise<ApiResult<schema.CustomerAdminB2BPortalsForms>> {
  let path = "/gaapi/customer/{customerId}/b2bportals/{corporateId}/deactivate/{portalType}";
  path = path.replace(
    "{customerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customerId),
  );
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  path = path.replace(
    "{portalType}",
    ((value) => {
      return ((value) => {
        const parsed_again = parseJsonWithNumbersAsBigint(value);
        assert(typeof parsed_again === "string");
        return parsed_again;
      })(
        (() => {
          return mapper.serialize_PortalType(value);
        })(),
      );
    })(props.portalType),
  );
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomerAdminB2BPortalsForms> => {
    return mapper.deserialize_CustomerAdminB2BPortalsForms(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getFreeAbstractCoupons(props: { customerId: number }): Promise<ApiResult<schema.CustomerAdminFreeAbstractCoupons>> {
  let path = "/gaapi/customer/{customerId}/freeAbstractCoupons";
  path = path.replace(
    "{customerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customerId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomerAdminFreeAbstractCoupons> => {
    return mapper.deserialize_CustomerAdminFreeAbstractCoupons(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getFreeDownloads(props: { customerId: number }): Promise<ApiResult<schema.CustomerAdminB2BPortalsForms>> {
  let path = "/gaapi/customer/{customerId}/freedownloads";
  path = path.replace(
    "{customerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customerId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomerAdminB2BPortalsForms> => {
    return mapper.deserialize_CustomerAdminB2BPortalsForms(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getMobileAppSettings(props: { customerId: number }): Promise<ApiResult<schema.CustomerAdminMobileAppForm>> {
  let path = "/gaapi/customer/{customerId}/mobile";
  path = path.replace(
    "{customerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customerId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomerAdminMobileAppForm> => {
    return mapper.deserialize_CustomerAdminMobileAppForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function setMobileAppLoginPreference(props: { body: schema.CustomerAdminMobileAppForm; customerId: number }): Promise<ApiResult<schema.CustomerAdminMobileAppForm>> {
  let path = "/gaapi/customer/{customerId}/mobile/loginPreference";
  path = path.replace(
    "{customerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customerId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_CustomerAdminMobileAppForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomerAdminMobileAppForm> => {
    return mapper.deserialize_CustomerAdminMobileAppForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function revokeMobileAppToken(props: { customerId: number; token: string }): Promise<ApiResult<schema.CustomerAdminMobileAppForm>> {
  let path = "/gaapi/customer/{customerId}/mobile/token/{token}";
  path = path.replace(
    "{customerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customerId),
  );
  path = path.replace(
    "{token}",
    ((value) => {
      return ((value) => {
        const parsed_again = parseJsonWithNumbersAsBigint(value);
        assert(typeof parsed_again === "string");
        return parsed_again;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.token),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomerAdminMobileAppForm> => {
    return mapper.deserialize_CustomerAdminMobileAppForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function resetLoginThrottler(props: { customerId: number }): Promise<ApiResult<schema.CustomerAdminAccountDetailForm>> {
  let path = "/gaapi/customer/{customerId}/resetLoginThrottler";
  path = path.replace(
    "{customerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customerId),
  );
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomerAdminAccountDetailForm> => {
    return mapper.deserialize_CustomerAdminAccountDetailForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getB2CSubscriptions(props: { customerId: number }): Promise<ApiResult<schema.CustomerAdminSubscriptionsForm>> {
  let path = "/gaapi/customer/{customerId}/subscriptions";
  path = path.replace(
    "{customerId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.customerId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomerAdminSubscriptionsForm> => {
    return mapper.deserialize_CustomerAdminSubscriptionsForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function quickSearchCustomers(props: { body: schema.CustomerSearchForm }): Promise<ApiResult<schema.CustomerAdminQuickSearchResult>> {
  const path = "/gaapi/customers/admin-quicksearch";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_CustomerSearchForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomerAdminQuickSearchResult> => {
    return mapper.deserialize_CustomerAdminQuickSearchResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function searchCustomers(props: { body: schema.CustomerSearchForm }): Promise<ApiResult<schema.CustomerAdminListViewArray>> {
  const path = "/gaapi/customers/admin-search";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_CustomerSearchForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.CustomerAdminListViewArray> => {
    return mapper.deserialize_CustomerAdminListViewArray(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function validateFormFile(props: { body: schema.DemoFormFile }): Promise<ApiResult<schema.DemoFormFile>> {
  const path = "/gaapi/demo-page/form/file";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_DemoFormFile(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.DemoFormFile> => {
    return mapper.deserialize_DemoFormFile(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getTemplates(props: { categoryId: number }): Promise<ApiResult<schema.EmailTemplateCategoryInfo>> {
  let path = "/gaapi/emailtool/categories/{categoryId}/templates";
  path = path.replace(
    "{categoryId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.categoryId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.EmailTemplateCategoryInfo> => {
    return mapper.deserialize_EmailTemplateCategoryInfo(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function saveTemplate(props: { body: schema.EmailTemplateForm; categoryId: number; templateId: number }): Promise<ApiResult<schema.EmailTemplateEditView>> {
  let path = "/gaapi/emailtool/categories/{categoryId}/templates/{templateId}";
  path = path.replace(
    "{categoryId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.categoryId),
  );
  path = path.replace(
    "{templateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.templateId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_EmailTemplateForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.EmailTemplateEditView> => {
    return mapper.deserialize_EmailTemplateEditView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function deleteTemplate(props: { categoryId: number; templateId: number }): Promise<ApiResult> {
  let path = "/gaapi/emailtool/categories/{categoryId}/templates/{templateId}";
  path = path.replace(
    "{categoryId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.categoryId),
  );
  path = path.replace(
    "{templateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.templateId),
  );
  const response = await gaApiCall({ path: path, method: "DELETE", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function testTemplate(props: { body: schema.EmailTemplateTestForm; categoryId: number; templateId: number }): Promise<ApiResult<schema.EmailTemplateTestResult>> {
  let path = "/gaapi/emailtool/categories/{categoryId}/templates/{templateId}/test";
  path = path.replace(
    "{categoryId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.categoryId),
  );
  path = path.replace(
    "{templateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.templateId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_EmailTemplateTestForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.EmailTemplateTestResult> => {
    return mapper.deserialize_EmailTemplateTestResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getEmailPools(): Promise<ApiResult<schema.EmailPoolAdminListView>> {
  const path = "/gaapi/emailtool/pools";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.EmailPoolAdminListView> => {
    return mapper.deserialize_EmailPoolAdminListView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function updateEmailPool(props: { body: schema.EmailPoolForm; poolName: string }): Promise<ApiResult<schema.EmailPoolAdminUpdateResult>> {
  let path = "/gaapi/emailtool/pools/{poolName}";
  path = path.replace(
    "{poolName}",
    ((value) => {
      return ((value) => {
        const parsed_again = parseJsonWithNumbersAsBigint(value);
        assert(typeof parsed_again === "string");
        return parsed_again;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.poolName),
  );
  const response = await gaApiCall({
    path: path,
    method: "PUT",
    requestBody: ((value) => {
      return mapper.serialize_EmailPoolForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.EmailPoolAdminUpdateResult> => {
    return mapper.deserialize_EmailPoolAdminUpdateResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function createEmailPool(props: { body: schema.EmailPoolForm; poolName: string }): Promise<ApiResult<schema.EmailPoolAdminCreateResult>> {
  let path = "/gaapi/emailtool/pools/{poolName}";
  path = path.replace(
    "{poolName}",
    ((value) => {
      return ((value) => {
        const parsed_again = parseJsonWithNumbersAsBigint(value);
        assert(typeof parsed_again === "string");
        return parsed_again;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.poolName),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_EmailPoolForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.EmailPoolAdminCreateResult> => {
    return mapper.deserialize_EmailPoolAdminCreateResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getEmailRepositories(): Promise<ApiResult<schema.EmailRepositoryAdminListView>> {
  const path = "/gaapi/emailtool/repositories";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.EmailRepositoryAdminListView> => {
    return mapper.deserialize_EmailRepositoryAdminListView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getEmailRepositoryById(props: { repositoryId: number }): Promise<ApiResult<schema.EmailRepositoryAdminView>> {
  let path = "/gaapi/emailtool/repositories/{repositoryId}";
  path = path.replace(
    "{repositoryId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.repositoryId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.EmailRepositoryAdminView> => {
    return mapper.deserialize_EmailRepositoryAdminView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getExpertVideos(): Promise<ApiResult<schema.ExpertVideoAdminOverview>> {
  const path = "/gaapi/expertvideos/admin";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.ExpertVideoAdminOverview> => {
    return mapper.deserialize_ExpertVideoAdminOverview(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function saveExpertVideoAdminForm(props: { body: schema.ExpertVideoAdminForm; expertVideoId: bigint }): Promise<ApiResult<schema.ExpertVideoSaveResponse>> {
  let path = "/gaapi/expertvideos/{expertVideoId}/admin";
  path = path.replace(
    "{expertVideoId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.expertVideoId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_ExpertVideoAdminForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.ExpertVideoSaveResponse> => {
    return mapper.deserialize_ExpertVideoSaveResponse(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getRecordedExpertVideos(props: { body: schema.ExpertVideoPagingInfo }): Promise<ApiResult<schema.ExpertVideosResult>> {
  const path = "/gaapi/expertvideos/getRecordedExpertVideos";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_ExpertVideoPagingInfo(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.ExpertVideosResult> => {
    return mapper.deserialize_ExpertVideosResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function createExport(): Promise<ApiResult<schema.BytesData>> {
  const path = "/gaapi/explore/export";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.BytesData> => {
    return mapper.deserialize_BytesData(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getFeatures(): Promise<ApiResult<schema.FeatureTypeArr>> {
  const path = "/gaapi/features";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.FeatureTypeArr> => {
    return mapper.deserialize_FeatureTypeArr(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function submitLeadForm(props: { body: schema.LeadForm }): Promise<ApiResult<schema.LeadCreationResponse>> {
  const path = "/gaapi/lead-form";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_LeadForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.LeadCreationResponse> => {
    return mapper.deserialize_LeadCreationResponse(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function applyAITag(props: { body: schema.ReferencedLearningItem }): Promise<ApiResult> {
  const path = "/gaapi/learning-items/applyAiTags";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_ReferencedLearningItem(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function applyProxmityScore(props: { body: schema.ReferencedLearningItem }): Promise<ApiResult> {
  const path = "/gaapi/learning-items/applyProximityScore";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_ReferencedLearningItem(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function generateMiab(props: { dataId: number }): Promise<ApiResult<schema.GenerateMiabAdminResponse>> {
  let path = "/gaapi/miab/admin";
  const urlSearchParams = new URLSearchParams();
  [props.dataId].flat().forEach((value) => {
    urlSearchParams.append(
      "dataId",
      ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      ),
    );
  });
  if (urlSearchParams.size > 0) {
    path += "?";
    path += urlSearchParams.toString();
  }
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.GenerateMiabAdminResponse> => {
    return mapper.deserialize_GenerateMiabAdminResponse(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getAiSuggestion(props: { body: schema.MiabAiSuggestionRequest }): Promise<ApiResult<schema.MiabAiSuggestionResponse>> {
  const path = "/gaapi/miab/aiSuggestion";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_MiabAiSuggestionRequest(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.MiabAiSuggestionResponse> => {
    return mapper.deserialize_MiabAiSuggestionResponse(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function deleteMiab(props: { miabId: bigint }): Promise<ApiResult> {
  let path = "/gaapi/miab/{miabId}/delete";
  path = path.replace(
    "{miabId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.miabId),
  );
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function getNewestSummaries(props: { corporateId: number; daysBack: number; pageRequest: schema.PageRequest }): Promise<ApiResult<schema.PagedSummaryListView>> {
  let path = "/gaapi/portal-admin-overview/{corporateId}/summaries";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const urlSearchParams = new URLSearchParams();
  [props.daysBack].flat().forEach((value) => {
    urlSearchParams.append(
      "daysBack",
      ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      ),
    );
  });
  (() => {
    const outerParsed = ((value) => {
      const outerRendered = ((value) => {
        return mapper.serialize_PageRequest(value);
      })(value);
      const outerParsed = parseJsonWithNumbersAsBigint(outerRendered);
      assert(outerParsed !== null);
      assert(typeof outerParsed === "object");
      return outerParsed;
    })(props.pageRequest);
    assert(hasProp(outerParsed, "page"));
    [outerParsed.page].flat().forEach((value) => {
      urlSearchParams.append(
        "page",
        ((value) => {
          return value;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "psize"));
    [outerParsed.psize].flat().forEach((value) => {
      urlSearchParams.append(
        "psize",
        ((value) => {
          return value;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "sortBy"));
    [outerParsed.sortBy].flat().forEach((value) => {
      if (value === null) return;
      urlSearchParams.append(
        "sortBy",
        ((value) => {
          const parsed_again = parseJsonWithNumbersAsBigint(value);
          assert(typeof parsed_again === "string");
          return parsed_again;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "sortDesc"));
    [outerParsed.sortDesc].flat().forEach((value) => {
      urlSearchParams.append(
        "sortDesc",
        ((value) => {
          const parsed_again = parseJsonWithNumbersAsBigint(value);
          assert(typeof parsed_again === "boolean");
          return parsed_again ? "true" : "false";
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
  })();
  if (urlSearchParams.size > 0) {
    path += "?";
    path += urlSearchParams.toString();
  }
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.PagedSummaryListView> => {
    return mapper.deserialize_PagedSummaryListView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getUnpaidInvoices(): Promise<ApiResult<schema.InvoicePaymentCardViewList>> {
  const path = "/gaapi/pps/invoices";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.InvoicePaymentCardViewList> => {
    return mapper.deserialize_InvoicePaymentCardViewList(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function pay(props: { body: schema.InvoicePaymentParameters }): Promise<ApiResult> {
  const path = "/gaapi/pps/invoices";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_InvoicePaymentParameters(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function getLanguages(): Promise<ApiResult<schema.DropdownEntryList>> {
  const path = "/gaapi/pps/select/languages";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.DropdownEntryList> => {
    return mapper.deserialize_DropdownEntryList(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getProducts(): Promise<ApiResult<schema.ProductAdminViewList>> {
  const path = "/gaapi/products";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.ProductAdminViewList> => {
    return mapper.deserialize_ProductAdminViewList(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getVisibleProducts(): Promise<ApiResult<schema.ProductAdminViewList>> {
  const path = "/gaapi/visible-products";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.ProductAdminViewList> => {
    return mapper.deserialize_ProductAdminViewList(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getCountries(props: { isoCode: schema.Language }): Promise<ApiResult<schema.Countries>> {
  let path = "/gaapi/prospect/countries";
  const urlSearchParams = new URLSearchParams();
  [props.isoCode].flat().forEach((value) => {
    urlSearchParams.append(
      "isoCode",
      ((value) => {
        const parsed_again = parseJsonWithNumbersAsBigint(value);
        assert(typeof parsed_again === "string");
        return parsed_again;
      })(
        (() => {
          return mapper.serialize_Language(value);
        })(),
      ),
    );
  });
  if (urlSearchParams.size > 0) {
    path += "?";
    path += urlSearchParams.toString();
  }
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.Countries> => {
    return mapper.deserialize_Countries(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getUserCountry(): Promise<ApiResult<schema.Country>> {
  const path = "/gaapi/prospect/country";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.Country> => {
    return mapper.deserialize_Country(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getRightsManagersDropdown(): Promise<ApiResult<schema.DropdownEntryList>> {
  const path = "/gaapi/rights-manager/selection";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.DropdownEntryList> => {
    return mapper.deserialize_DropdownEntryList(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getReports(props: { corporateId: number }): Promise<ApiResult<schema.PagedReportListView>> {
  let path = "/gaapi/stats/b2b/{corporateId}/reports";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.PagedReportListView> => {
    return mapper.deserialize_PagedReportListView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getExportedReports(props: { corporateId: number }): Promise<ApiResult<schema.PagedExportReportListView>> {
  let path = "/gaapi/stats/b2b/{corporateId}/reports/exported";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.PagedExportReportListView> => {
    return mapper.deserialize_PagedExportReportListView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function initB2bReport(props: { corporateId: number }): Promise<ApiResult<schema.B2BStatsReportPageProps>> {
  let path = "/gaapi/stats/b2b/{corporateId}/reports/init";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.B2BStatsReportPageProps> => {
    return mapper.deserialize_B2BStatsReportPageProps(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getReport(props: { corporateId: number; reportId: number }): Promise<ApiResult<schema.NewB2BReportForm>> {
  let path = "/gaapi/stats/b2b/{corporateId}/reports/{reportId}";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  path = path.replace(
    "{reportId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.reportId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.NewB2BReportForm> => {
    return mapper.deserialize_NewB2BReportForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function saveReport(props: { body: schema.NewB2BReportForm; corporateId: number; reportId: number }): Promise<ApiResult<schema.B2BStatsReportSaveResponse>> {
  let path = "/gaapi/stats/b2b/{corporateId}/reports/{reportId}";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  path = path.replace(
    "{reportId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.reportId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_NewB2BReportForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.B2BStatsReportSaveResponse> => {
    return mapper.deserialize_B2BStatsReportSaveResponse(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function deleteReport(props: { corporateId: number; reportId: number }): Promise<ApiResult> {
  let path = "/gaapi/stats/b2b/{corporateId}/reports/{reportId}/delete";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  path = path.replace(
    "{reportId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.reportId),
  );
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function runReport(props: { corporateId: number; reportId: number }): Promise<ApiResult> {
  let path = "/gaapi/stats/b2b/{corporateId}/reports/{reportId}/run";
  path = path.replace(
    "{corporateId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.corporateId),
  );
  path = path.replace(
    "{reportId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.reportId),
  );
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function sendConfirmationEmail(props: { body: schema.ResendConfirmationEmailForm; subscriptionId: number }): Promise<ApiResult<schema.ResendConfirmationEmailForm>> {
  let path = "/gaapi/subscriptions/confirmation-email/{subscriptionId}";
  path = path.replace(
    "{subscriptionId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.subscriptionId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_ResendConfirmationEmailForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.ResendConfirmationEmailForm> => {
    return mapper.deserialize_ResendConfirmationEmailForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getSubscriptionCredit(props: { subscriptionId: number; transactionTypeId: number }): Promise<ApiResult<schema.SubscriptionCreditView>> {
  let path = "/gaapi/subscriptions/credit/{subscriptionId}/{transactionTypeId}";
  path = path.replace(
    "{subscriptionId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.subscriptionId),
  );
  path = path.replace(
    "{transactionTypeId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.transactionTypeId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.SubscriptionCreditView> => {
    return mapper.deserialize_SubscriptionCreditView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function creditSubscription(props: { body: schema.SubscriptionCreditForm; subscriptionId: number; transactionTypeId: number }): Promise<ApiResult<schema.SubscriptionCreditForm>> {
  let path = "/gaapi/subscriptions/credit/{subscriptionId}/{transactionTypeId}";
  path = path.replace(
    "{subscriptionId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.subscriptionId),
  );
  path = path.replace(
    "{transactionTypeId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.transactionTypeId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_SubscriptionCreditForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.SubscriptionCreditForm> => {
    return mapper.deserialize_SubscriptionCreditForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function renewSubscription(props: { body: schema.RenewSubscriptionForm; subscriptionId: number }): Promise<ApiResult<schema.RenewSubscriptionForm>> {
  let path = "/gaapi/subscriptions/renew/{subscriptionId}";
  path = path.replace(
    "{subscriptionId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.subscriptionId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_RenewSubscriptionForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.RenewSubscriptionForm> => {
    return mapper.deserialize_RenewSubscriptionForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function deleteRenewal(props: { subscriptionId: number }): Promise<ApiResult> {
  let path = "/gaapi/subscriptions/renew/{subscriptionId}";
  path = path.replace(
    "{subscriptionId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.subscriptionId),
  );
  const response = await gaApiCall({ path: path, method: "DELETE", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function getSubscription(props: { subscriptionId: number }): Promise<ApiResult<schema.SubscriptionAdminView>> {
  let path = "/gaapi/subscriptions/{subscriptionId}";
  path = path.replace(
    "{subscriptionId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.subscriptionId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.SubscriptionAdminView> => {
    return mapper.deserialize_SubscriptionAdminView(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function updateSubscription(props: { body: schema.SubscriptionAdminForm; subscriptionId: number }): Promise<ApiResult<schema.SubscriptionAdminForm>> {
  let path = "/gaapi/subscriptions/{subscriptionId}";
  path = path.replace(
    "{subscriptionId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.subscriptionId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_SubscriptionAdminForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.SubscriptionAdminForm> => {
    return mapper.deserialize_SubscriptionAdminForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function deleteSubscription(props: { subscriptionId: number }): Promise<ApiResult> {
  let path = "/gaapi/subscriptions/{subscriptionId}";
  path = path.replace(
    "{subscriptionId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.subscriptionId),
  );
  const response = await gaApiCall({ path: path, method: "DELETE", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function getBulkLoadSummaries(props: { body: schema.SummaryBulkLoadForm }): Promise<ApiResult<schema.SummaryMetadataArray>> {
  const path = "/gaapi/summaries-bulk-load/admin";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_SummaryBulkLoadForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.SummaryMetadataArray> => {
    return mapper.deserialize_SummaryMetadataArray(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getSummary(props: { dataId: number }): Promise<ApiResult<schema.ContentMetadata_SUMMARY>> {
  let path = "/gaapi/summary/{dataId}";
  path = path.replace(
    "{dataId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.dataId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.ContentMetadata_SUMMARY> => {
    return mapper.deserialize_ContentMetadata_SUMMARY(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function validateWarmupEditForm(props: { body: schema.WarmupEditForm }): Promise<ApiResult<schema.WarmupValidationResult>> {
  const path = "/gaapi/validation/warmup";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_WarmupEditForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.WarmupValidationResult> => {
    return mapper.deserialize_WarmupValidationResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function validateWarmupB2bEditForm(props: { body: schema.WarmupEitherEditForm_B2B }): Promise<ApiResult<schema.WarmupB2bValidationResult>> {
  const path = "/gaapi/validation/warmupb2b";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_WarmupEitherEditForm_B2B(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.WarmupB2bValidationResult> => {
    return mapper.deserialize_WarmupB2bValidationResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function validateWarmupB2cEditForm(props: { body: schema.WarmupEitherEditForm_B2C }): Promise<ApiResult<schema.WarmupB2cValidationResult>> {
  const path = "/gaapi/validation/warmupb2c";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_WarmupEitherEditForm_B2C(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.WarmupB2cValidationResult> => {
    return mapper.deserialize_WarmupB2cValidationResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function validateWarmupEitherEditForm(props: { body: schema.WarmupEitherEditForm }): Promise<ApiResult<schema.WarmupEitherValidationResult>> {
  const path = "/gaapi/validation/warmupeither";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_WarmupEitherEditForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.WarmupEitherValidationResult> => {
    return mapper.deserialize_WarmupEitherValidationResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function validateWarmupSsoEditForm(props: { body: schema.WarmupEitherEditForm_SSO }): Promise<ApiResult<schema.WarmupSsoValidationResult>> {
  const path = "/gaapi/validation/warmupsso";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_WarmupEitherEditForm_SSO(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.WarmupSsoValidationResult> => {
    return mapper.deserialize_WarmupSsoValidationResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function validateWarmupTrialEditForm(props: { body: schema.WarmupEitherEditForm_TRIAL }): Promise<ApiResult<schema.WarmupTrialValidationResult>> {
  const path = "/gaapi/validation/warmuptrial";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_WarmupEitherEditForm_TRIAL(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.WarmupTrialValidationResult> => {
    return mapper.deserialize_WarmupTrialValidationResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function createVerifaiContentForm(props: { body: schema.VerifaiContentForm }): Promise<ApiResult<schema.VerifaiContentForm>> {
  const path = "/gaapi/verifai/content";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_VerifaiContentForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.VerifaiContentForm> => {
    return mapper.deserialize_VerifaiContentForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getAutofillPromptTemplate(): Promise<ApiResult<string>> {
  const path = "/gaapi/verifai/content/autofill-prompt-template";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<string> => {
    const data = parseJsonWithNumbersAsBigint(value);
    return ((value) => {
      if (typeof value !== "string") {
        return {
          success: false,
          reason: `[class StringSchema {
    class Schema {
        type: string
        format: null
        $ref: null
        description: null
        title: null
        multipleOf: null
        maximum: null
        exclusiveMaximum: null
        minimum: null
        exclusiveMinimum: null
        maxLength: null
        minLength: null
        pattern: null
        maxItems: null
        minItems: null
        uniqueItems: null
        maxProperties: null
        minProperties: null
        required: null
        not: null
        properties: null
        additionalProperties: null
        nullable: null
        readOnly: null
        writeOnly: null
        example: null
        externalDocs: null
        deprecated: null
        discriminator: null
        xml: null
    }
}]: '${value}' expected to be of type string.`,
        };
      }
      return { success: true, value: value };
    })(data);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getVerifaiContentForm(props: { verifaiContentId: bigint }): Promise<ApiResult<schema.VerifaiContentForm>> {
  let path = "/gaapi/verifai/content/{verifaiContentId}";
  path = path.replace(
    "{verifaiContentId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.verifaiContentId),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.VerifaiContentForm> => {
    return mapper.deserialize_VerifaiContentForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function saveVerifaiContentForm(props: { body: schema.VerifaiContentForm; verifaiContentId: bigint }): Promise<ApiResult<schema.VerifaiContentForm>> {
  let path = "/gaapi/verifai/content/{verifaiContentId}";
  path = path.replace(
    "{verifaiContentId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.verifaiContentId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_VerifaiContentForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.VerifaiContentForm> => {
    return mapper.deserialize_VerifaiContentForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function autofillContent(props: { body: schema.VerifaiAutofillRequest; verifaiContentId: bigint }): Promise<ApiResult<schema.VerifaiContentForm>> {
  let path = "/gaapi/verifai/content/{verifaiContentId}/autofill";
  path = path.replace(
    "{verifaiContentId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.verifaiContentId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_VerifaiAutofillRequest(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.VerifaiContentForm> => {
    return mapper.deserialize_VerifaiContentForm(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function getVerifaiOverview(props: { body: schema.VerifaiOverviewFilters; pageRequest: schema.PageRequest }): Promise<ApiResult<schema.PagedVerifaiOverview>> {
  let path = "/gaapi/verifai/overview";
  const urlSearchParams = new URLSearchParams();
  (() => {
    const outerParsed = ((value) => {
      const outerRendered = ((value) => {
        return mapper.serialize_PageRequest(value);
      })(value);
      const outerParsed = parseJsonWithNumbersAsBigint(outerRendered);
      assert(outerParsed !== null);
      assert(typeof outerParsed === "object");
      return outerParsed;
    })(props.pageRequest);
    assert(hasProp(outerParsed, "page"));
    [outerParsed.page].flat().forEach((value) => {
      urlSearchParams.append(
        "page",
        ((value) => {
          return value;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "psize"));
    [outerParsed.psize].flat().forEach((value) => {
      urlSearchParams.append(
        "psize",
        ((value) => {
          return value;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "sortBy"));
    [outerParsed.sortBy].flat().forEach((value) => {
      if (value === null) return;
      urlSearchParams.append(
        "sortBy",
        ((value) => {
          const parsed_again = parseJsonWithNumbersAsBigint(value);
          assert(typeof parsed_again === "string");
          return parsed_again;
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
    assert(hasProp(outerParsed, "sortDesc"));
    [outerParsed.sortDesc].flat().forEach((value) => {
      urlSearchParams.append(
        "sortDesc",
        ((value) => {
          const parsed_again = parseJsonWithNumbersAsBigint(value);
          assert(typeof parsed_again === "boolean");
          return parsed_again ? "true" : "false";
        })(
          (() => {
            return renderJsonWithNumbersAsBigint(value);
          })(),
        ),
      );
    });
  })();
  if (urlSearchParams.size > 0) {
    path += "?";
    path += urlSearchParams.toString();
  }
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_VerifaiOverviewFilters(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.PagedVerifaiOverview> => {
    return mapper.deserialize_PagedVerifaiOverview(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function processWarmupEditForm(props: { body: schema.WarmupEditForm }): Promise<ApiResult<schema.WarmupValidationResult>> {
  const path = "/gaapi/warmup";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_WarmupEditForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.WarmupValidationResult> => {
    return mapper.deserialize_WarmupValidationResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function validateWarmupEditFormManual(props: { body: schema.WarmupEditForm }): Promise<ApiResult<schema.WarmupValidationResult>> {
  const path = "/gaapi/warmup/validate";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_WarmupEditForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.WarmupValidationResult> => {
    return mapper.deserialize_WarmupValidationResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function validateWarmupB2bEditFormManual(props: { body: schema.WarmupEitherEditForm_B2B }): Promise<ApiResult<schema.WarmupB2bValidationResult>> {
  const path = "/gaapi/warmup/validate/b2b";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_WarmupEitherEditForm_B2B(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.WarmupB2bValidationResult> => {
    return mapper.deserialize_WarmupB2bValidationResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function validateWarmupB2cEditFormManual(props: { body: schema.WarmupEitherEditForm_B2C }): Promise<ApiResult<schema.WarmupB2cValidationResult>> {
  const path = "/gaapi/warmup/validate/b2c";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_WarmupEitherEditForm_B2C(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.WarmupB2cValidationResult> => {
    return mapper.deserialize_WarmupB2cValidationResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function validateWarmupEitherEditFormManual(props: { body: schema.WarmupEitherEditForm }): Promise<ApiResult<schema.WarmupEitherValidationResult>> {
  const path = "/gaapi/warmup/validate/either";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_WarmupEitherEditForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.WarmupEitherValidationResult> => {
    return mapper.deserialize_WarmupEitherValidationResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function validateWarmupSsoEditFormManual(props: { body: schema.WarmupEitherEditForm_SSO }): Promise<ApiResult<schema.WarmupSsoValidationResult>> {
  const path = "/gaapi/warmup/validate/sso";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_WarmupEitherEditForm_SSO(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.WarmupSsoValidationResult> => {
    return mapper.deserialize_WarmupSsoValidationResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function validateWarmupTrialEditFormManual(props: { body: schema.WarmupEitherEditForm_TRIAL }): Promise<ApiResult<schema.WarmupTrialValidationResult>> {
  const path = "/gaapi/warmup/validate/trial";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_WarmupEitherEditForm_TRIAL(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.WarmupTrialValidationResult> => {
    return mapper.deserialize_WarmupTrialValidationResult(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error" };
  }
  return { kind: "success", data: deserialized.value };
}

export async function updateManagingEditor(props: { body: schema.WishlistManagementEditorUpdate; kRecId: number }): Promise<ApiResult> {
  let path = "/gaapi/wishlist-management/{kRecId}/editor";
  path = path.replace(
    "{kRecId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.kRecId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_WishlistManagementEditorUpdate(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function updateLanguage(props: { body: schema.WishlistManagementLanguageUpdate; kRecId: number }): Promise<ApiResult> {
  let path = "/gaapi/wishlist-management/{kRecId}/language";
  path = path.replace(
    "{kRecId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.kRecId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return mapper.serialize_WishlistManagementLanguageUpdate(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function markRejected(props: { kRecId: number }): Promise<ApiResult> {
  let path = "/gaapi/wishlist-management/{kRecId}/reject";
  path = path.replace(
    "{kRecId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.kRecId),
  );
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}

export async function markToReview(props: { kRecId: number }): Promise<ApiResult> {
  let path = "/gaapi/wishlist-management/{kRecId}/review";
  path = path.replace(
    "{kRecId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.kRecId),
  );
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}
